<template>
    <div id="modal-richmedia" class="hidden fixed block top-0 left-0 w-screen h-screen z-40 bg-white overflow-auto">
        <!-- summary -->
        <div class="fixed top-3 left-3 flex">
            <btn-summary/>
        </div>

        <!-- close -->
        <div class="fixed top-3 right-3 flex w-6 h-6 text-gray-900 justify-center items-center cursor-pointer" @click="$eventbus.$emit('modal:richmedia:hide')">
            <span class="icon-times text-3xl"></span>
        </div>

        <!-- content -->
        <div class="container mx-auto px-3 my-20">
            <div class="flex flex-row flex-wrap justify-center items-start">
                <template v-for="page in getChapterPages(options.page, options.pages)">
                    <template v-for="collection_name in getCollectionsNameFromRichmediaOfPage(page)">


                        <template v-if="getRichmediaByCollection(page, collection_name)[0].type === 'link' ">
                            <a :href=" getRichmediaByCollection(page, collection_name)[0].src " class="w-64 h-56  m-3 inline-block relative" target="_blank">
                                <modal-richmedia-box :options="{
                                    page: options.page,
                                    collection_name: collection_name,
                                    collection: getRichmediaByCollection(page, collection_name)
                                }"/>
                            </a>
                        </template>

                        <template v-else>
                            <div class="w-64 h-52 m-3 inline-block relative" style="object-fit: contain;" @click="richmediaShowDiaporama(getRichmediaByCollection(page, collection_name))">
                                <modal-richmedia-box :options="{
                                    page: options.page,
                                    collection_name: collection_name,
                                    collection: getRichmediaByCollection(page, collection_name)
                                }"/>
                            </div>
                        </template>

                    </template>
                </template>

            </div>
        </div>
    </div>
</template>

<script>

import RichmediaMixin from "../mixins/RichmediaMixin";
import ModalRichmediaBox from "./ModalRichmediaBox";

export default {
    name: "ModalRichmedia",
    components: {ModalRichmediaBox},
    mixins: [RichmediaMixin],
    props: {
        options: {
            pages: null,
            page: null,
        }
    },
    mounted() {
        let vm = this;
        let BtnAllow = document.querySelector('.scrolltop')

        $eventbus.$on('modal:richmedia:show', function () {
            // console.log('modal:richmedia:show | ', vm.$el);
            vm.$el.classList.remove('hidden');
            vm.$el.classList.add('block');

            document.body.classList.add('overflow-hidden');

            // console.log(document.querySelector('.scrolltop'))
             if(document.querySelector('.scrolltop') && document.querySelector('.scrolltop')) {
                document.querySelector('.scrolltop').querySelector('img').style = "display:none"
            }

            $eventbus.$emit('gtag', {
                method:'event',
                action: 'diaporama-richmedia',
                params:{
                    event_category : 'general',
                    event_label : 'diaporama-richmedia',
                    value : vm.$route.fullPath,
                }
            });

        });
        $eventbus.$on('modal:richmedia:hide', function () {
            // console.log('modal:richmedia:hide | ', vm.$el);
            vm.$el.classList.remove('block');
            vm.$el.classList.add('hidden');

            document.body.classList.remove('overflow-hidden');

              if(document.querySelector('.scrolltop') && (document.querySelector('.scrolltop').querySelector('img').style = "display:none")) {
                document.querySelector('.scrolltop').querySelector('img').style = "display:block"
            }
        });
    },


}
</script>

